import { gql } from '@apollo/client'

export const SEPOMEX_MUTATION = gql`
  mutation GetFullAddressByZipcodeMutation($zipCode: Int!) {
    getFullAddressByZipcode(zipCode: $zipCode) {
      id
      colonies {
        id_colony
        colony_name
      }
      id_municipality
      municipality_name
      id_city
      city_name
      id_state
      state_name
      id_country
      country_name
    }
  }
`

export const GET_ALL_ZIPCODES_TLAJOMULCO_SEARCH = gql`
  mutation GetAllZipCodesBySearchToTlajomulco($search: String) {
    getAllZipCodesBySearchToTlajomulco(search: $search)
  }
`

export const GET_ALL_COLONIES_BY_ZIPCODE_TLAJOMULCO = gql`
  mutation GetAllColoniesByZipcodeToTlajomulco($zipCode: Int!) {
    colonies: getAllColoniesByZipcodeToTlajomulco(zipCode: $zipCode)
  }
`

export const GET_ALL_COLONIES = gql`
  query GetAllColonies {
    getAllColonies {
      id
      name
      nocolonia
    }
  }
`

export const ALL_COLONIES = gql`
  mutation AllColonies {
    allColonies {
      id
      name
      id_municipality
      zip_code
      nocolonia
    }
  }
`
